import { render, staticRenderFns } from "./modify-field.vue?vue&type=template&id=0bdbb8b4&"
import script from "./modify-field.vue?vue&type=script&lang=js&"
export * from "./modify-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports